import React from 'react';
import styled from '@emotion/styled';
import { useNotification } from '../../contexts/NotificationContext';
import { CheckCircle, XCircle, AlertCircle, X } from 'lucide-react';

const NotificationContainer = styled.div`
  position: fixed;
  top: 80px;
  right: 20px;
  z-index: 9999;
  display: flex;
  flex-direction: column;
  gap: 10px;
  pointer-events: none;
`;

const NotificationItem = styled.div`
  pointer-events: auto;
  min-width: 300px;
  padding: 16px;
  border-radius: 8px;
  background: white;
  box-shadow: 0 4px 12px rgba(0, 0, 0, 0.15);
  display: flex;
  align-items: center;
  gap: 12px;
  animation: slideIn 0.3s ease-out;
  border-left: 4px solid ${props => {
        switch (props.type) {
            case 'success': return '#10b981';
            case 'error': return '#ef4444';
            case 'warning': return '#f59e0b';
            default: return '#3b82f6';
        }
    }};

  @keyframes slideIn {
    from { transform: translateX(100%); opacity: 0; }
    to { transform: translateX(0); opacity: 1; }
  }

  @media (max-width: 480px) {
    min-width: calc(100vw - 40px);
    right: 10px;
    left: 10px;
  }
`;

const IconWrapper = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;
  color: ${props => {
        switch (props.type) {
            case 'success': return '#10b981';
            case 'error': return '#ef4444';
            case 'warning': return '#f59e0b';
            default: return '#3b82f6';
        }
    }};
`;

const Message = styled.div`
  flex: 1;
  font-size: 14px;
  color: #1f2937;
  font-weight: 500;
`;

export const NotificationDisplay = () => {
    const { notifications } = useNotification();

    const getIcon = (type) => {
        switch (type) {
            case 'success': return <CheckCircle size={20} />;
            case 'error': return <XCircle size={20} />;
            case 'warning': return <AlertCircle size={20} />;
            default: return <AlertCircle size={20} />;
        }
    };

    return (
        <NotificationContainer>
            {notifications.map((notif) => (
                <NotificationItem key={notif.id} type={notif.type}>
                    <IconWrapper type={notif.type}>
                        {getIcon(notif.type)}
                    </IconWrapper>
                    <Message>{notif.message}</Message>
                </NotificationItem>
            ))}
        </NotificationContainer>
    );
};
